var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.f4011137980e47bfda677629d5121063.svg#q';
                    var viewUrl = 'sprites.f4011137980e47bfda677629d5121063.svg#view-q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };